/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Ticketpreviewdoorpay3Inputs */

const en_ticketpreviewdoorpay3 = /** @type {(inputs: Ticketpreviewdoorpay3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You pay ${i?.amount} at the door`)
};

const de_ticketpreviewdoorpay3 = /** @type {(inputs: Ticketpreviewdoorpay3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} zahlst du vor Ort`)
};

/**
* | output |
* | --- |
* | "You pay {amount} at the door" |
*
* @param {Ticketpreviewdoorpay3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewdoorpay3 = /** @type {((inputs: Ticketpreviewdoorpay3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewdoorpay3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewdoorpay3(inputs)
	return de_ticketpreviewdoorpay3(inputs)
});
export { ticketpreviewdoorpay3 as "ticketPreviewDoorPay" }